import { emailFlagsFromApi, emailFlagsToApi } from '../Common/emailFlags';

const createSchoolModel = (school = {}) => {
  return {
    id: school.id || null,
    name: school.name || '',
    cnpj: school.cnpj || '',
    groupId: school.group?.id || '',
    unitId: school.unit?.id || '',
    schoolId: school.school?.id || '',
    slug: school.slug || '',
    image: school.image || '',
    hideAnalysisPractice: school.hide_analysis_practice || false,
    hideAnalysisSimulation: school.hide_analysis_simulation || false,
    hideReports: school.hide_reports || false,
    hideCustomTests: school.hide_custom_tests || false,
    showOnSignup: school.show_on_signup || false,
    signUpEmailSaml: school.sign_up_email_saml || false,
    showRanking: school.show_ranking || false,
    hasSimulations: school.has_simulations || false,
    contentType: school.content_type?.id || '',
    hidePractice: school.hide_practice || false,
    hideQrCodeCertificate: school.hide_qr_code_certificate || false,
    hideCategoriesScoreCertificate:
      school.hide_categories_score_certificate || false,
    scoreControl: school.score_control || false,
    scoreAvailable: school.score_available ?? true,
    certificateAvailable: school.certificate_available ?? true,
    emailSettings: school.email_settings ?? true,
    ...emailFlagsFromApi(school),
    language: school.language || '',
    roundedCefrCertificate: school.rounded_cefr_certificate || false,
    roundedOverall: school.rounded_overall || false,
    roundedCategories: school.rounded_categories || false,
    twoFactorMode: school.two_factor_mode || 'disabled',
    twoFactorTotpEnabled: school.two_factor_totp_enabled || false,
    twoFactorEmailEnabled: school.two_factor_email_enabled || false,
  };
};

const createSchoolRequestModel = (school = {}) => {
  const schoolRequestModel = {
    id: school.id,
    name: school.name,
    cnpj: school.cnpj,
    group_id: school.groupId,
    unit_id: school.unitId,
    school_id: school.schoolId,
    slug: school.slug,
    hide_analysis_practice: school.hideAnalysisPractice,
    hide_analysis_simulation: school.hideAnalysisSimulation,
    hide_reports: school.hideReports,
    hide_custom_tests: school.hideCustomTests,
    show_on_signup: school.showOnSignup,
    sign_up_email_saml: school.signUpEmailSaml,
    show_ranking: school.showRanking,
    has_simulations: school.hasSimulations,
    content_type_id: school.contentType,
    hide_practice: school.hidePractice,
    hide_qr_code_certificate: school.hideQrCodeCertificate,
    hide_categories_score_certificate: school.hideCategoriesScoreCertificate,
    score_control: school.scoreControl,
    score_available: school.scoreAvailable,
    certificate_available: school.certificateAvailable,
    email_settings: school.emailSettings,
    ...emailFlagsToApi(school),
    language: school.language,
    rounded_cefr_certificate: school.roundedCefrCertificate,
    rounded_overall: school.roundedOverall,
    rounded_categories: school.roundedCategories,
    two_factor_mode: school.twoFactorMode,
    two_factor_totp_enabled: school.twoFactorTotpEnabled,
    two_factor_email_enabled: school.twoFactorEmailEnabled,
  };

  if (school.image instanceof File) schoolRequestModel.image = school.image;

  return schoolRequestModel;
};

export { createSchoolModel, createSchoolRequestModel };
